<template>
  <div class="switchbar">
    <div class="switchbar__wrap">
      <small>Estás viendo:</small>
      <div class="switchbar__seg" role="navigation" aria-label="Cambiar de camino">
        <a
          v-for="domain in domains"
          :key="domain.id"
          :href="landingSectionHref(domain.anchor)"
          :class="domain.id === activeId ? `is-${domain.trackState}` : ''"
          @click="onOpen($event, domain.anchor)"
        >
          {{ labelFor(domain.trackState) }}
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { landingSectionHref, navigateToLandingSection } from '@/utils/landingHomeNavigation'
import type { LandingDomain } from '@/types/landingCatalog.types'

export default defineComponent({
  name: 'HomePathSwitch',

  props: {
    domains: {
      type: Array as PropType<LandingDomain[]>,
      required: true,
    },
  },

  setup() {
    return { landingSectionHref }
  },

  data() {
    return {
      activeId: '',
    }
  },

  created() {
    this.activeId = this.domains[0]?.id ?? ''
  },

  mounted() {
    this.markActive()
    window.addEventListener('scroll', this.markActive, { passive: true })
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.markActive)
  },

  methods: {
    labelFor(state: LandingDomain['trackState']) {
      return state === 'compartir' ? '👥 Compartirla' : '✍️ Escribirla'
    },

    markActive() {
      const community = this.domains.find((domain) => domain.trackState === 'compartir')
      const write = this.domains.find((domain) => domain.trackState === 'escribir')
      if (!community || !write) return
      const node = document.getElementById(community.anchor)
      if (!node) return
      const inCommunity = node.getBoundingClientRect().top < window.innerHeight * 0.45
      this.activeId = inCommunity ? community.id : write.id
    },

    async onOpen(event: MouseEvent, anchor: string) {
      event.preventDefault()
      await navigateToLandingSection(this.$router, anchor)
    },
  },
})
</script>

<style scoped>
.switchbar {
  position: sticky;
  top: var(--landing-nav-height, 4rem);
  z-index: 20;
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid #e6e6e6;
  backdrop-filter: blur(8px);
}

.switchbar__wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 60px;
  width: min(1200px, 100%);
  margin: 0 auto;
  padding: 0 24px;
}

.switchbar small {
  color: #5b6b7f;
  font-size: 13.5px;
  font-weight: 600;
}

.switchbar__seg {
  display: inline-flex;
  padding: 4px;
  border-radius: 999px;
  background: #f1f2f3;
}

.switchbar__seg a {
  padding: 8px 16px;
  border-radius: 999px;
  color: #1d3557;
  font-weight: 700;
  font-size: 14.5px;
  text-decoration: none;
}

.switchbar__seg a.is-escribir {
  background: #e06a00;
  color: #fff;
}

.switchbar__seg a.is-compartir {
  background: #145c78;
  color: #fff;
}

@media (max-width: 640px) {
  .switchbar__wrap {
    height: 56px;
    padding: 0 18px;
  }

  .switchbar small {
    display: none;
  }
}
</style>
